import moment from 'moment';
import PropTypes from 'prop-types';
import FeatherIcon from 'feather-icons-react';
import { useDispatch, useSelector } from 'react-redux';
import React, { useState, useEffect } from 'react';
import { useHistory } from "react-router-dom";
import { Empty, Table, message, Card, Typography, Collapse, Divider, Row, Col, Spin, Popover, Skeleton } from 'antd';
import { generateDynamicColumns, generateUsersTableData } from '../Pages/AllTableColumns/TaskTable';
import { AllRelatedTask } from "../../../Api/Services/TaskapiService";
import { useExcryptedNavigation } from '../Filters/FilterConditions';
// import { getColumnConfigs } from "../../../Api/Services/CommonApiService";
import { DetailsOtherInfoUser } from '../Pages/GlobalComponents/UserCardCmnts'
import TaskColumnFields from '../MassupdateJson/TaskColumns.json'
import { TaskIcon } from '../../../components/Icons/Icons';
import { Cards } from '../../../components/cards/frame/cards-frame'
import CustomHtmlParser from '../Email/CustomHtmlParser'

const { Text } = Typography; // Title
const { Panel } = Collapse;

const UserTable = ({ UrlId, listingType, listingValues, setSelectedKeys, NacTrigger, queryAction, refreshTrigger, tabKey }) => {
    const dispatch = useDispatch();
    const localData = useSelector((state) => state.localRedux);
    const ProfileData = localData.profile
    const profile = ProfileData
    const companyProfile = localData.company
    function convertAndFormatDateTime(dateTime, company, profile) {
        if (!dateTime || !company?.timeZone || !profile?.timeZone) return "";
        const extractTimezoneName = (tzStr) => {
            const match = tzStr.match(/\)\s*([A-Za-z/_]+)/);
            return match ? match[1] : "";
        };
        const fromTimezone = extractTimezoneName(company?.timeZone);
        const toTimezone = extractTimezoneName(profile?.timeZone);
        if (!moment.tz.zone(fromTimezone) || !moment.tz.zone(toTimezone)) {
            console.warn("Invalid timezone provided");
            return "";
        }
        const converted = moment.tz(dateTime, fromTimezone).tz(toTimezone)
        const dateFormat = profile?.dateFormate && profile?.dateFormate !== "" ? profile.dateFormate : "YYYY-MM-DD";
        const formattedDate = converted.format(dateFormat);
        // const rawTime = converted.format("HH:mm");
        // const formattedTime = convertTime(rawTime, profile?.timeFormat);

        return formattedDate
    }
    const history = useHistory();
    const tasktype = "TASK"
    const [sortedInfo, setSortedInfo] = useState()
    const [leads, setLeads] = useState()
    const [tasks, setTasks] = useState([])
    const [states, setStates] = useState({
        selectedRows: [],
        selectedRowKeys: [],
    });
    const [checkboxValues] = useState(TaskColumnFields)
    const [openPage, setOpenPage] = useState(Array(leads?.length).fill(false));
    const handleOpenPageChange = (index) => {
        const newPopoverOpenStates = [...openPage];
        newPopoverOpenStates[index] = !newPopoverOpenStates[index];
        setOpenPage(newPopoverOpenStates);
    };
    const rowSelection = {
        onChange: (selectedRowKeys, selectedRows) => {
            setStates({ ...states, selectedRowKeys, selectedRows });
            setSelectedKeys(selectedRowKeys)
        },
        getCheckboxProps: (record) => {
            const permission = record.taskData
            if (["Update", "OwnerChange", "Delete", "Sharing"].includes(queryAction)) {
                if (!permission) return { disabled: false };
                const isCreatedByUser = record.created_by === profile.userId;
                const isOwner = record.task_owner === profile.userId;
                const isNotAllowed = !(isCreatedByUser || isOwner);
                return {
                    disabled: isNotAllowed
                };
            }
            return { disabled: false };
        }
    };
    const { ExcryptedNavigation } = useExcryptedNavigation()
    const ViewDetailPage = (id, entity) => {
        ExcryptedNavigation("Nav", id, entity, history, dispatch, null, null)
    }
    async function AllTask(type, id) {
        try {
            const data = await AllRelatedTask(type, id)
            const SortedData = data.sort((a, b) => b.task_id - a.task_id);
            setLeads(SortedData)
        } catch (error) {
            message.error(error);
        }
    };
    const convertTime = (timeStr, timeFormat) => {
        let hours;
        let minutes;
        let period;
        if (timeStr.toLowerCase().includes('am') || timeStr.toLowerCase().includes('pm')) {
            // Parse 12-hour time string
            const timeParts = timeStr.match(/(\d{1,2}):(\d{2})/);
            hours = parseInt(timeParts[1], 10);
            minutes = parseInt(timeParts[2], 10);
            period = timeStr.match(/(am|pm)/i)[0].toLowerCase();

            if (period === 'pm' && hours !== 12) {
                hours += 12;
            } else if (period === 'am' && hours === 12) {
                hours = 0;
            }
        } else {
            // Parse 24-hour time string
            const timeParts = timeStr.split(':');
            hours = parseInt(timeParts[0], 10);
            minutes = parseInt(timeParts[1], 10);
        }
        if (timeFormat === '12hrs' || timeFormat === '12-hour') {
            period = hours >= 12 ? 'PM' : 'AM';
            hours = hours % 12 || 12;
            return `${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')} ${period}`;
        }
        // No need for an else here because we return in the if above
        if (timeFormat === '24hrs' || timeFormat === '24-hour') {
            return `${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}`;
        }
        throw new Error('Invalid time format specified');
    };
    useEffect(() => {
        if (listingType !== "Query") {
            if (refreshTrigger === tabKey) {
                if (UrlId !== undefined && UrlId !== null && UrlId[0] === "?LEAD") {
                    AllTask("Lead", UrlId[1])
                }
                else if (UrlId !== undefined && UrlId !== null && UrlId[0] === "?CONTACT") {
                    AllTask("Contact", UrlId[1])
                }
                else if (UrlId !== undefined && UrlId !== null && UrlId[0] === "?ACCOUNT") {
                    AllTask("Account", UrlId[1])
                }
                else if (UrlId !== undefined && UrlId !== null && UrlId[0] === "?DEAL") {
                    AllTask("Deal", UrlId[1])
                }
                else if (UrlId !== undefined && UrlId !== null && UrlId[0] === "?CASE") {
                    AllTask("Case", UrlId[1])
                }
                else if (UrlId !== undefined && UrlId !== null && UrlId[0] === "?FCASE") {
                    AllTask("Case", UrlId[1])
                }
            }
        }
    }, [UrlId, NacTrigger, refreshTrigger, tabKey])
    useEffect(() => {
        if (listingType === "Query") {
            const SortedData = listingValues.sort((a, b) => b.task_id - a.task_id);
            const transformedData = SortedData.map(item => ({
                ...item,
                created_at: item.created_at ? convertAndFormatDateTime(item.created_time ? `${item.created_at} ${item.created_time}` : item.created_at, companyProfile, profile) : "",
                modified_at: item.modified_at ? convertAndFormatDateTime(item.modified_time ? `${item.modified_at} ${item.modified_time}` : item.modified_at, companyProfile, profile) : "",
            }));
            setTasks(transformedData)
        }
    }, [listingType, listingValues])
    const handleTableChange = async (_, _1, sorter) => {
        setSortedInfo(sorter)
    }
    const dynamicColumns = generateDynamicColumns(checkboxValues, ViewDetailPage, sortedInfo);
    const usersTableData = generateUsersTableData(tasks, ViewDetailPage);
    function convertAndFormatDateTime2(dateTime, company, profile) {
        if (!dateTime || !company?.timeZone || !profile?.timeZone) return "";

        const extractTimezoneName = (tzStr) => {
            const match = tzStr.match(/\)\s*([A-Za-z/_]+)/);
            return match ? match[1] : "";
        };

        const fromTimezone = extractTimezoneName(company?.timeZone);
        const toTimezone = extractTimezoneName(profile?.timeZone);

        if (!moment.tz.zone(fromTimezone) || !moment.tz.zone(toTimezone)) {
            console.warn("Invalid timezone provided");
            return "";
        }

        const converted = moment.tz(dateTime, fromTimezone).tz(toTimezone);

        // Get raw and formatted time
        const timeFormat = profile?.timeFormat && profile?.timeFormat !== "" ? profile.timeFormat : "24hrs";
        const rawTime = converted.format("HH:mm");
        const formattedTime = convertTime(rawTime, timeFormat);

        // Check if the date is today in the same target timezone
        const today = moment.tz(toTimezone).startOf('day');
        const isToday = converted.isSame(today, 'day');

        if (isToday) {
            return `Today, ${formattedTime}`;
        }
        const formattedDate = converted.format("MMM DD, YYYY");
        return `${formattedDate}, ${formattedTime}`;
    }
    const TableSkeleton = () => {
        const skeletonRowStyle = {
            padding: '13px 20px',
            height: '68px',
            borderBottom: '1px solid #f0f0f0',
        };
        return (
            <div>
                {Array.from({ length: 5 }).map((_, idx) => (
                    <div key={idx} style={skeletonRowStyle}>
                        <Skeleton
                            avatar paragraph={{ rows: 2, width: '100%' }}
                            active
                            title={false}
                        />
                    </div>
                ))}
            </div>
        );
    };
    const LoadingCiolums = [
        {
            title: (
                <Skeleton
                    paragraph={{ rows: 1, width: '100%' }}
                    active
                    title={false}
                />
            ),
            dataIndex: 'name',
            key: 'name',
        },]
    return (
        <>
            {listingType === "Query" ?
                <div className='Listing-PagePadding' style={{ width: "100%" }}>
                    <Cards headless bodyStyle={{ borderRadius: '10px' }}>
                        <div className="table-bordered leaderboard-table table-responsive">
                            <Table
                                showSorterTooltip={false}
                                rowSelection={rowSelection}
                                dataSource={usersTableData}
                                columns={!tasks ? LoadingCiolums : dynamicColumns}
                                locale={{
                                    emptyText: !tasks ? (
                                        <TableSkeleton rows={5} />
                                    ) :
                                        tasks.length === 0 && <Empty />
                                }}
                                onChange={handleTableChange}
                                pagination={{
                                    defaultPageSize: 5,
                                    total: usersTableData.length,
                                    showTotal: (total, range) => `${range[0]}-${range[1]} of ${total} items`,
                                }} />
                        </div>
                    </Cards>
                </div>
                :
                <>{leads ? (leads?.length > 0 ?
                    leads?.map((item, index) => {
                        const Name = `${item.userFirstName} ${item.userLastName}`;
                        const formattedTimeDifference = convertAndFormatDateTime2(item.created_time ? `${item.created_at} ${item.created_time}` : item.created_at, companyProfile, profile)
                        const isPresent = item.allow
                        return (
                            <div key={index} style={{ marginBottom: 15 }}>
                                <Card className="DetailsTabCard">
                                    <Collapse bordered={false} className="DetailsTabCollapse">
                                        <Panel
                                            header={
                                                <div style={{ display: "flex", alignItems: "center" }}>
                                                    <TaskIcon height={16} width={16} marginRight={5} />
                                                    {/* <Text strong> Task by {Name}</Text> */}
                                                    <Text strong style={{ marginRight: 5 }} title={item.task_name}>{item.task_name.length > 30 ? `${item.task_name.slice(0, 30)}...` : item.task_name}</Text><div className={`task-Tag status-text Task${item.priority}`} style={{ marginTop: 1, marginRight: 3 }}>{item.priority}</div>
                                                    <span style={{ color: "#adb4d2", marginRight: 3 }}>|</span> <span style={{ color: "#adb4d2", fontSize: 12, marginTop: "0.2rem" }}>{Name}</span>
                                                </div>
                                            }
                                            key="1"
                                            extra={<div style={{ display: "flex", alignItems: "center", gap: 10 }}>
                                                <div style={{ display: "flex", alignItems: "center" }}>
                                                    <FeatherIcon icon="clock" size={16} style={{ marginRight: 5 }} />{formattedTimeDifference}
                                                </div>
                                                {isPresent ?
                                                    <Popover
                                                        placement="bottom"
                                                        content={
                                                            <div >
                                                                <div className="text_icon newHover-class"
                                                                    role="button"
                                                                    tabIndex={0} title='View Details'
                                                                    onClick={() => {
                                                                        ViewDetailPage(item.task_id, tasktype)
                                                                        handleOpenPageChange(index)
                                                                    }}
                                                                    onKeyDown={(event) => {
                                                                        if (event.key === 'Enter' || event.key === ' ') {
                                                                            ViewDetailPage(item.task_id, tasktype)
                                                                            handleOpenPageChange(index)
                                                                        }
                                                                    }}
                                                                    aria-label='view'>
                                                                    <FeatherIcon icon="eye" size={16} style={{ marginRight: 5 }} /> View Details
                                                                </div>
                                                            </div>
                                                        }
                                                        trigger="hover"
                                                        open={openPage[index]}
                                                        onOpenChange={() => handleOpenPageChange(index)}
                                                    >
                                                        <FeatherIcon icon="more-vertical" size={18} style={{ cursor: "pointer" }} />
                                                    </Popover> : ""}
                                            </div>}
                                        >
                                            <Divider style={{ margin: 0 }} />
                                            <div style={{ marginTop: 10 }}>
                                                <Text type="secondary">
                                                    <Text type="secondary">{item.description && item.description !== "" ? <CustomHtmlParser html={item.description} key={index} page="Previewss" /> : "Task Description"}</Text>
                                                </Text>
                                            </div>
                                            <Divider style={{ margin: "10px 0" }} />
                                            <Row gutter={16}>
                                                <Col span={7} style={{
                                                    borderRight: "1px solid #dddddd"
                                                }}>
                                                    <Text type="secondary" className='RightSide-Lable'>Due Date</Text>
                                                    <br />
                                                    <Text>{item.due_date && profile.dateFormate ? moment(item.due_date).format(profile.dateFormate) : (item.due_date && moment(item.due_date).format("YYYY-MM-DD"))}</Text>
                                                </Col>
                                                <Col span={7} style={{
                                                    borderRight: "1px solid #dddddd"
                                                }}>
                                                    <Text type="secondary" className='RightSide-Lable'>Status</Text>
                                                    <br />
                                                    <div className={`status-text Task${item.task_status_id}`}>{item.task_status_name}</div>
                                                </Col>
                                                <Col span={10}>
                                                    <Text type="secondary" className='RightSide-Lable'>Assignee</Text>
                                                    <br />
                                                    <DetailsOtherInfoUser record={{
                                                        recordbyFName: item?.assigneeFirstName,
                                                        recordbyLName: item?.assigneeLastName,
                                                        recordby: item?.assign_to,
                                                    }} pageRef="ReTask" />
                                                </Col>
                                            </Row>
                                        </Panel>
                                    </Collapse>
                                </Card>
                            </div>
                        )
                    }) :
                    <div style={{ padding: "10%" }}>
                        <Empty />
                    </div>)
                    :
                    <div className="spin">
                        <Spin />
                    </div>
                }
                </>}
        </>
    );
}
UserTable.propTypes = {
    queryAction: PropTypes.string.isRequired,
    listingType: PropTypes.string.isRequired,
    UrlId: PropTypes.array.isRequired,
    listingValues: PropTypes.array.isRequired,
    setSelectedKeys: PropTypes.func.isRequired,
    NacTrigger: PropTypes.string.isRequired,
    refreshTrigger: PropTypes.string.isRequired,
    tabKey: PropTypes.string.isRequired,
};
export default React.memo(UserTable)